import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=38c253aa&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=38c253aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c253aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c253aa')) {
      api.createRecord('38c253aa', component.options)
    } else {
      api.reload('38c253aa', component.options)
    }
    module.hot.accept("./AppSidebar.vue?vue&type=template&id=38c253aa&scoped=true", function () {
      api.rerender('38c253aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-sidebar/AppSidebar.vue"
export default component.exports